import { render } from "./Header.vue?vue&type=template&id=ae3333dc&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=ae3333dc&lang=scss&scoped=true"
import "./Header.vue?vue&type=style&index=1&id=ae3333dc&lang=sass&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3333dc"]])

export default __exports__